import React from 'react';
import { cx } from './cx';

export type ButtonVariant = 'primary' | 'secondary' | 'accent' | 'danger' | 'ghost';
export type ButtonSize = 'sm' | 'md' | 'lg';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  /** Shows a spinner and disables the button while an action runs. */
  loading?: boolean;
  icon?: React.ReactNode;
  block?: boolean;
}

/**
 * primary   – the one main action in a view (Save, Approve)
 * secondary – neutral alternatives (Cancel, Export)
 * accent    – emphasised secondary CTA (Reschedule)
 * danger    – destructive actions; always behind a confirm
 * ghost     – low-emphasis inline actions and links
 */
const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant = 'secondary', size = 'md', loading, icon, block, className, children, disabled, type, ...rest }, ref) => (
    <button
      ref={ref}
      type={type ?? 'button'}
      className={cx('ds-btn', `ds-btn--${variant}`, size !== 'md' && `ds-btn--${size}`, block && 'ds-btn--block', className)}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading ? <span className="ds-btn__spinner" aria-hidden /> : icon}
      {children}
    </button>
  ),
);
Button.displayName = 'Button';

export default Button;
